export default "__VITE_ASSET__Akc_Xz3e__"